import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const MATCH_URL = 'scribd.com';
const PATTERN = /^https?:\/\/(www\.)?scribd\.com\/(doc|document|read)\/(\d+)\/.+/;

const DEFAULT_WIDTH = '475px';
const DEFAULT_HEIGHT = '355px';

export const matchScribd: ProviderMatcher = (url, params) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}
	const match = PATTERN.exec(url);
	if (!match) {
		return null;
	}
	const docId = match[3];
	// The legacy renderer screen-scraped scribd.com to retrieve an `access_key` server-side.
	// We cannot perform that lookup safely in the browser, so we fall back to the public
	// no-access-key embed URL which works for publicly shared documents.
	return {
		kind: 'iframe',
		provider: 'Scribd',
		embedUrl: `//www.scribd.com/embeds/${docId}/content?start_page=1&view_mode=scroll&show_recommendations=false`,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
